import App from './core/App'

document.addEventListener('DOMContentLoaded', () => {
	new App().init()
})
